import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import debounce from 'lodash.debounce';
import { cx } from 'emotion';
import { Deselected, Selected } from './shapes/radio';
import { alloy, teal, white } from './colors';
import { useMemoizedId } from './utils';
export var RADIO_NAME = 'CimRadio';

var Radio = function Radio(_ref) {
  var id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      whiteBackground = _ref.whiteBackground,
      className = _ref.className,
      onCheck = _ref.onCheck,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      style = _ref.style;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var debouncedChange = debounce(function (e, debouncedValue) {
    onCheck && onCheck(e, debouncedValue);
  }, 200, {
    leading: true,
    trailing: false
  });

  var handleBlur = function handleBlur(e) {
    onBlur && onBlur(e);
  };

  var handleFocus = function handleFocus(e) {
    onFocus && onFocus(e);
  };

  var handleMouseOver = function handleMouseOver() {
    setHover(true);
  };

  var handleMouseOut = function handleMouseOut() {
    setHover(false);
  };

  var handleChange = function handleChange(e) {
    e.persist();
    debouncedChange(e, value);
  };

  var inputId = useMemoizedId({
    id: id,
    label: label
  });
  var backgroundColor = whiteBackground ? white : undefined;
  var image;

  if (checked) {
    image = disabled ? React.createElement(Selected, {
      color: alloy,
      backgroundColor: backgroundColor
    }) : React.createElement(Selected, {
      backgroundColor: backgroundColor
    });
  } else {
    image = disabled ? React.createElement(Deselected, {
      color: alloy,
      backgroundColor: backgroundColor
    }) : hover ? React.createElement(Deselected, {
      color: teal.base,
      backgroundColor: backgroundColor
    }) : React.createElement(Deselected, {
      backgroundColor: backgroundColor
    });
  }

  var disabledStyle = disabled ? {
    cursor: 'not-allowed',
    pointerEvents: 'none'
  } : {};
  return React.createElement("div", {
    className: cx('checkbox', className),
    style: _objectSpread({}, style, {}, disabledStyle)
  }, React.createElement("label", {
    className: cx('control-label', {
      'text-muted': disabled
    }),
    htmlFor: inputId,
    onClick: disabled ? undefined : handleChange,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    style: _objectSpread({
      paddingLeft: 0
    }, disabledStyle)
  }, React.createElement("span", {
    style: {
      position: 'relative',
      top: '3px',
      paddingRight: '10px'
    }
  }, image), React.createElement("input", {
    id: inputId,
    name: name,
    type: "radio",
    disabled: disabled,
    checked: checked,
    value: value,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    style: {
      opacity: 0,
      marginLeft: '-15px'
    }
  }), label));
};

export default Radio;
Radio.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.node,
  value: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  disabled: PropTypes.bool,
  whiteBackground: PropTypes.bool,
  className: PropTypes.string,
  onCheck: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  style: StylePropType
};
Radio.displayName = RADIO_NAME;
Radio.defaultProps = {
  disabled: false,
  className: '',
  whiteBackground: false
};